/**
 * Puschies Größentabelle (blocks/p-size-chart.liquid): setzt den Link „Größentabelle“ in die Legende der
 * Größen-Option des Variant-Pickers (auch nach Re-Render beim Variantenwechsel). Klick öffnet den Dialog des Blocks.
 * Findet sich keine Größen-Option, bleibt der Link an der Block-Position sichtbar.
 */

function init(root) {
  if (root.dataset.pSizeChartInit) return;
  root.dataset.pSizeChartInit = '1';

  const inline = root.querySelector('[data-p-size-chart-inline]');
  if (!inline) return;

  const names = String(root.dataset.optionNames || 'größe,size')
    .toLowerCase()
    .split(',')
    .map((name) => name.trim())
    .filter(Boolean);
  const scope = root.closest('.shopify-section') || document;

  const injectTrigger = () => {
    let found = false;
    scope.querySelectorAll('variant-picker fieldset legend').forEach((legend) => {
      const nameEl = legend.querySelector('.p-option-name');
      const label = (nameEl ? nameEl.textContent : legend.firstChild?.textContent || '').toLowerCase();
      if (!names.some((name) => label.includes(name))) return;
      found = true;
      if (legend.querySelector('.p-size-chart-trigger')) return;
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'p-size-chart-trigger';
      trigger.textContent = inline.textContent.trim();
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        root.showDialog();
      });
      legend.appendChild(trigger);
    });
    root.classList.toggle('is-injected', found);
  };

  injectTrigger();
  new MutationObserver(injectTrigger).observe(scope, { childList: true, subtree: true });
}

const boot = () => document.querySelectorAll('[data-p-size-chart]').forEach(init);

if (customElements.get('dialog-component')) boot();
else customElements.whenDefined('dialog-component').then(boot);
document.addEventListener('shopify:section:load', boot);
